import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CartService } from "../../../shared/cart.service";

@Component({
  selector: 'app-current-printgroup-status-bar',
  templateUrl: './current-printgroup-status-bar.component.html',
  styleUrls: ['./current-printgroup-status-bar.component.scss'],
  standalone: false
})
export class CurrentPrintgroupStatusBarComponent implements OnInit {
  @Output() filesUploaded = new EventEmitter();
  @Input() files;
  @Input() printProduct;
  @Input() printingGroupFiles;

  constructor(private cartService: CartService) {
  }

  ngOnInit() {
  }

  filesUploadedEvent(event: any) {
    this.filesUploaded.emit(event);
  }

  checkFolderName(event) {
    const folderName = event.target.value;
    if (!folderName.length) {
      const index = this.cartService.getPrintProductsInCart().length;
      this.printProduct.product.folderName = `Carpeta ${index}`;
    }
    this.cartService.saveCart(this.cartService.cart);
  }
}
